import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { IoGiftOutline } from 'react-icons/io5';
import { hasMinimumRole } from '../../utils/permissions';

const ChangelogIcon = () => {
  const initializedRef = useRef(false);
  // Canny updates are trainer-facing (they announce trainer features), so the
  // changelog only shows for trainers+, never clients.
  const role = useSelector((s) => s.auth?.user?.role);
  const isTrainerPlus = hasMinimumRole(role, 'trainer');

  useEffect(() => {
    if (typeof window === 'undefined' || !isTrainerPlus) return;

    const initCanny = () => {
      if (initializedRef.current || !window.Canny) return;

      try {
        window.Canny('initChangelog', {
          appID: '6a75f29a7e1f3262389c0ee5',
          position: 'bottom',
          align: 'right', // Fixed: Added required align parameter
        });
        console.log('Canny changelog initialized ✅');
        initializedRef.current = true;
      } catch (err) {
        console.error('Error initializing changelog:', err);
      }
    };

    if (document.getElementById('canny-jssdk')) {
      if (window.Canny) initCanny();
      return;
    }

    const script = document.createElement('script');
    script.id = 'canny-jssdk';
    script.src = 'https://canny.io/sdk.js';
    script.async = true;
    script.onload = () => {
      console.log('Canny SDK loaded');
      initCanny();
    };
    script.onerror = () => {
      console.error('Failed to load Canny SDK');
    };
    document.head.appendChild(script);

    return () => {
      if (window.Canny && initializedRef.current) {
        try {
          window.Canny('closeChangelog');
        } catch (err) {
          console.error('Error closing changelog:', err);
        }
      }
    };
  }, [isTrainerPlus]);

  // Hide the changelog entirely for clients.
  if (!isTrainerPlus) return null;

  return (
    <button
      data-canny-changelog
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        width: '20px',
        height: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        color: 'var(--color-primary-text, #1f2937)',
        transition: 'all 0.3s ease',
        position: 'relative',
        padding: '0',
      }}
    >
      <IoGiftOutline />
    </button>
  );
};

export default ChangelogIcon;
